/**
 * @generated SignedSource<<55d719e9b6b97a961513a530f9eb126f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SubscriptionPurchaseEventMutation$variables = {
  transactionId: string;
};
export type SubscriptionPurchaseEventMutation$data = {
  readonly updateTrialSubscription: {
    readonly subscriptions: ReadonlyArray<{
      readonly czk: number | null;
      readonly transactionId: string;
    }>;
  } | null;
};
export type SubscriptionPurchaseEventMutation = {
  response: SubscriptionPurchaseEventMutation$data;
  variables: SubscriptionPurchaseEventMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "transactionId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "transactionId",
    "variableName": "transactionId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Subscription",
  "kind": "LinkedField",
  "name": "subscriptions",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transactionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "czk",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscriptionPurchaseEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "updateTrialSubscription",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SubscriptionPurchaseEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "updateTrialSubscription",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b785c2cfbcb985bc870f945bcbf224f1",
    "id": null,
    "metadata": {},
    "name": "SubscriptionPurchaseEventMutation",
    "operationKind": "mutation",
    "text": "mutation SubscriptionPurchaseEventMutation(\n  $transactionId: String!\n) {\n  updateTrialSubscription(transactionId: $transactionId) {\n    subscriptions {\n      transactionId\n      czk\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "84628160a36e1d61e87f784658c9cc2a";

export default node;
